import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { IDefaultOption } from '../../../page-builder/interface/customerInterface';
import { FieldLabel } from '@measured/puck';
import CustomTooltip from '../tooltip';

interface ToggleProps {
  value: string;
  onChange: (_value: string) => void;
  options: IDefaultOption[];
  label: string;
}

const ToggleGroup = ({ value, onChange, options, label }: ToggleProps) => {
  return (
    <FieldLabel
      label={
        (
          <CustomTooltip title="device">
            <span>{label}</span>
          </CustomTooltip>
        ) as React.ReactNode as string
      }
      el="div">
      <ToggleButtonGroup
        value={options?.find(option => option.value === value)?.value as string}
        exclusive
        className="w-full">
        {options.map((option, index: number) => (
          <ToggleButton
            key={index}
            size="small"
            onClick={() => onChange(option?.value)}
            value={option?.value as string}
            disableRipple
            aria-label={option.value}
            className="flex-1">
            {option.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </FieldLabel>
  );
};

export default ToggleGroup;
